import DateFilterService from '../../services/date-filter-service';
import BetSlipDetailsEvent from './model-mybets-details-items';
export default class MyBetsModel {
  constructor(data) {
    /**
     * @type {number}
     */
    this.betSlipGroupID = data.id;
    /**
     * @type {number}
     */
    this.userId = data.uid;
    /**
     * @type {string}
     */
    this.username = data.u;
    /**
     * @type {string}
     */
    this.createdOn = DateFilterService.localDate(
      data.c,
      'datetime',
      APP_SETTINGS.formatting.fullDateFormat,
      APP_SETTINGS.formatting.fullTimeFormat,
      true
    );
    /**
     * @type {string}
     */
    this.matchesType = data.ty;
    /**
     * @type {string}
     */
    this.betSlipGroupType = data.bty;
    /**
     * @type {string}
     */
    this.betSlipGroupStatus = data.st;
    /**
     * @type {number}
     */
    this.betSlipGroupStatusId = data.stid;
    /**
     * @type {number}
     */
    this.stake = data.s;
    /**
     * @type {number}
     */
    this.winnings = data.w;
    /**
     * @type {number}
     */
    this.odds = data.o;
    /**
     * @type {string}
     */
    this.currencyCode = data.cc;
    /**
     * @type {number}
     */
    this.combNumber = data.lc;
    /**
     * @type {string}
     */
    this.totalNumberOfItems = data.tot;
    this.potWinnings = 0;
    /**
     * @type {number}
     */
    this.eventCount = data.ec;
    /**
     * @type {string}
     */
    this.hasBetBuilderEvents = data.bbe || false;
    /**
     * @type {BetSlipDetailsEvent[]}
     * Matches array from betslip details
     */
    this.betslipDetailsMatches = data.bsd ? data.bsd.map((match) => new BetSlipDetailsEvent(match)) : [];
  }
}
